var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        {
          staticClass: "mb-2",
          attrs: { color: "primary", dark: "", dense: "", elevation: "0" }
        },
        [_c("span", [_vm._v("New Order Status")])]
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pb-0", attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "ID",
                  outlined: "",
                  dense: "",
                  "error-messages": _vm.orderStatusPostErrors.id || []
                },
                model: {
                  value: _vm.id,
                  callback: function($$v) {
                    _vm.id = $$v
                  },
                  expression: "id"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Name",
                  outlined: "",
                  dense: "",
                  "error-messages": _vm.orderStatusPostErrors.name || []
                },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", loading: _vm.orderStatusPosting },
                  on: { click: _vm.storeOrderStatus }
                },
                [_c("span", [_vm._v("Save")])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }